import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgResveratrolGlyphSecondary from './svgs/ResveratrolGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var resveratrolGlyph = (props => useIcon(null, SvgResveratrolGlyphSecondary, props));

export { resveratrolGlyph as default };
